import { render, staticRenderFns } from "./chooseLocation.vue?vue&type=template&id=9581c88e&"
import script from "./chooseLocation.vue?vue&type=script&lang=js&"
export * from "./chooseLocation.vue?vue&type=script&lang=js&"
import style0 from "./chooseLocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports